 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		12: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"2347c4b95f81fbf9f2a7ea3343c2711018696c5d","3":"022a3e3bc0f2148eaae77c03c5c65d7d365ac42d","4":"0920e9e2d8b4b256b2bdae9a2951db0cfa1bd0c6","5":"3c5e29c362319f7fd178a570aca8ee3849f781e8","6":"e923b657265286bf62cd1cec155943f8276fb32d","7":"357815cde94b64b0825afb28e6b30a79682659d5","8":"ea88be26","9":"f161bf7421e37e3f087d0e153486a98f8af09d4d","11":"fd180c1b2af7c7058ca7f29111b44de3449c636a","14":"component---src-pages-404-js","15":"component---src-pages-billing-agreement-index-js","16":"component---src-pages-careers-index-js","17":"component---src-pages-data-processing-addendum-index-js","18":"component---src-pages-index-js","19":"component---src-pages-outcomes-agencies-js","20":"component---src-pages-outcomes-b-2-b-marketing-analytics-js","21":"component---src-pages-outcomes-b-2-c-marketing-analytics-js","22":"component---src-pages-outcomes-engineers-and-it-js","23":"component---src-pages-outcomes-hipaa-marketing-data-js","24":"component---src-pages-outcomes-index-js","25":"component---src-pages-outcomes-marketing-leaders-js","26":"component---src-pages-outcomes-marketing-sales-ops-js","27":"component---src-pages-outcomes-marketing-specialists-js","28":"component---src-pages-outcomes-measurement-pros-js","29":"component---src-pages-platform-ai-insights-js","30":"component---src-pages-platform-analytics-js","31":"component---src-pages-platform-attribution-js","32":"component---src-pages-platform-automate-conversion-and-event-js","33":"component---src-pages-platform-automate-marketing-data-js","34":"component---src-pages-platform-centralized-marketing-data-js","35":"component---src-pages-platform-competitors-js","36":"component---src-pages-platform-consent-js","37":"component---src-pages-platform-cookieless-js","38":"component---src-pages-platform-enhance-js","39":"component---src-pages-platform-external-data-js","40":"component---src-pages-platform-google-analytics-alternative-js","41":"component---src-pages-platform-hippa-js","42":"component---src-pages-platform-monitoring-js","43":"component---src-pages-platform-server-side-tagging-js","44":"component---src-pages-platform-target-accounts-js","45":"component---src-pages-sub-processors-index-js","46":"component---src-pages-terms-and-policies-index-js","47":"component---src-templates-combination-js","48":"component---src-templates-cpt-listener-datalayersample-js","49":"component---src-templates-cpt-listener-help-js","50":"component---src-templates-cpt-listener-overview-js","51":"component---src-templates-cpt-listener-trackingintergration-js","52":"component---src-templates-cpt-listener-usecase-js","53":"component---src-templates-cpt-platform-datalayersample-js","54":"component---src-templates-cpt-platform-help-js","55":"component---src-templates-cpt-platform-listener-js","56":"component---src-templates-cpt-platform-overview-js","57":"component---src-templates-cpt-platform-usecase-js","58":"component---src-templates-listener-type-js","59":"component---src-templates-page-js","60":"component---src-templates-usecase-detail-js","61":"component---src-templates-usecase-type-js","62":"d0dd8ad8"}[chunkId]||chunkId) + "-" + {"0":"8dd0b05988610c10dc81","1":"e9d24b1846c7d6eb9685","2":"b18980c31d09d3e9b09b","3":"2b06b06db16e8d410152","4":"5259295697842ec48a8b","5":"ae324d3993b75347f64c","6":"5e415583bbc7218dd68b","7":"f52fa849c1b3c4938a42","8":"ca67f2304f00a37b39fc","9":"136b1b2f6e16c503b246","11":"b6603a9d3d21dadfd7b7","14":"0a9d29282a064aafb92c","15":"80e6ec3665f97a474d31","16":"b1c40477b4bf6e288bde","17":"8681cb62435a2a832045","18":"a60427d23222382b359a","19":"af9cc00a4eef5ccef8e5","20":"39be9feee00373c6f9b7","21":"68cf1cd14dfb1a074de7","22":"54e65ab1e197c26ab247","23":"5f250dc0e83fb5532340","24":"6105633c4668d4939a4c","25":"0155a24d621cab673fe4","26":"44e14a4762449eec34f2","27":"a7aa728a70456a729088","28":"01a6b7652b51a2b564f3","29":"e4bff191c1d295079d73","30":"901f734c84503894f213","31":"0e95052672858b215862","32":"6c34648331d9422f9b56","33":"cde67bbc08f8eb2aacee","34":"503e88d2476bb7b023a5","35":"b04723bbd2ebb56d8108","36":"9c74fc0d6765670c23b9","37":"4fa7148b1ac74d2f0484","38":"c663b00527d05377901d","39":"2c5b150b3409db0598b6","40":"f592b64e5353c2d7afdc","41":"27d2070da9d0dc58ce49","42":"b77424d78d8a36fe8541","43":"1e51686a9d654380b2ed","44":"91f2bb2aba4757133fc7","45":"9d2bb84aa4e329ae0de4","46":"585e330ff3289dfe8aaa","47":"d5475d0312fe252ab7ca","48":"22f4787742eb51eb198b","49":"f3b36b074f6c4f2dd782","50":"c15cd65743b66c1a9e23","51":"9339561ffaecf3657756","52":"9d591e2156de66f16208","53":"d98f6cb844b36fad2fcc","54":"0ec2c5f7413ac385d502","55":"b2c1e1ae1de30700a0d5","56":"461352ec50000c1ecf3c","57":"b96eb43334cac9d115a6","58":"3f2761300d2c4b133616","59":"70337305d7817dc482cc","60":"1866ea27f6b523dabf9a","61":"96cfb93acdad058b711a","62":"b6dd7da97ccbcefe2b11"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"2347c4b95f81fbf9f2a7ea3343c2711018696c5d","3":"022a3e3bc0f2148eaae77c03c5c65d7d365ac42d","4":"0920e9e2d8b4b256b2bdae9a2951db0cfa1bd0c6","5":"3c5e29c362319f7fd178a570aca8ee3849f781e8","6":"e923b657265286bf62cd1cec155943f8276fb32d","7":"357815cde94b64b0825afb28e6b30a79682659d5","8":"ea88be26","9":"f161bf7421e37e3f087d0e153486a98f8af09d4d","11":"fd180c1b2af7c7058ca7f29111b44de3449c636a","14":"component---src-pages-404-js","15":"component---src-pages-billing-agreement-index-js","16":"component---src-pages-careers-index-js","17":"component---src-pages-data-processing-addendum-index-js","18":"component---src-pages-index-js","19":"component---src-pages-outcomes-agencies-js","20":"component---src-pages-outcomes-b-2-b-marketing-analytics-js","21":"component---src-pages-outcomes-b-2-c-marketing-analytics-js","22":"component---src-pages-outcomes-engineers-and-it-js","23":"component---src-pages-outcomes-hipaa-marketing-data-js","24":"component---src-pages-outcomes-index-js","25":"component---src-pages-outcomes-marketing-leaders-js","26":"component---src-pages-outcomes-marketing-sales-ops-js","27":"component---src-pages-outcomes-marketing-specialists-js","28":"component---src-pages-outcomes-measurement-pros-js","29":"component---src-pages-platform-ai-insights-js","30":"component---src-pages-platform-analytics-js","31":"component---src-pages-platform-attribution-js","32":"component---src-pages-platform-automate-conversion-and-event-js","33":"component---src-pages-platform-automate-marketing-data-js","34":"component---src-pages-platform-centralized-marketing-data-js","35":"component---src-pages-platform-competitors-js","36":"component---src-pages-platform-consent-js","37":"component---src-pages-platform-cookieless-js","38":"component---src-pages-platform-enhance-js","39":"component---src-pages-platform-external-data-js","40":"component---src-pages-platform-google-analytics-alternative-js","41":"component---src-pages-platform-hippa-js","42":"component---src-pages-platform-monitoring-js","43":"component---src-pages-platform-server-side-tagging-js","44":"component---src-pages-platform-target-accounts-js","45":"component---src-pages-sub-processors-index-js","46":"component---src-pages-terms-and-policies-index-js","47":"component---src-templates-combination-js","48":"component---src-templates-cpt-listener-datalayersample-js","49":"component---src-templates-cpt-listener-help-js","50":"component---src-templates-cpt-listener-overview-js","51":"component---src-templates-cpt-listener-trackingintergration-js","52":"component---src-templates-cpt-listener-usecase-js","53":"component---src-templates-cpt-platform-datalayersample-js","54":"component---src-templates-cpt-platform-help-js","55":"component---src-templates-cpt-platform-listener-js","56":"component---src-templates-cpt-platform-overview-js","57":"component---src-templates-cpt-platform-usecase-js","58":"component---src-templates-listener-type-js","59":"component---src-templates-page-js","60":"component---src-templates-usecase-detail-js","61":"component---src-templates-usecase-type-js","62":"d0dd8ad8"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"883641019c3a7e725f89","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
